type StorageType = 'localStorage' | 'sessionStorage';

export const getStoredValue = (key: string, storageStype: StorageType = 'localStorage') => {
  try {
    if (window[storageStype]) {
      const value = window[storageStype].getItem(key);
      return value !== null && value !== undefined ? JSON.parse(value) : undefined;
    }
  } catch (error) {
    console.error(`Error accessing ${storageStype}:`, error);
    return undefined;
  }
};

export const setStoredValue = (key: string, value, storageStype: StorageType = 'localStorage') => {
  try {
    if (window[storageStype]) {
      window[storageStype].setItem(key, JSON.stringify(value));
    }
  } catch (error) {
    console.error(`Error accessing ${storageStype}:`, error);
  }
};
